module.exports = __webpack_public_path__ + "static/img/blog-09.d031803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-09.jpg
// module id = lSWk
// module chunks = 7